enum ReferrerTypeTracking {
  PARTNER = 'partner',
  CUSTOMER = 'customer',
  CONNECTOR = 'connector',
  SALES = 'sales',
  AFFILIATE = 'affiliate',
  DIGITAL_MARKETING = 'digitalMarketing',
  DIRECT = 'direct',
  OTHER = 'other',
}

enum AssistantTypeTracking {
  PARTNER = 'partner',
  SALES = 'sales',
  UNASSISTED = 'unassisted',
}

type ReferrerTrackingContext = {
  referrerType: ReferrerTypeTracking;
  referrerDetails?: string;
};

enum SalesMethodTracking {
  PartnerAssistedRemote = 'PartnerAssistedRemote',
  SalesAssisted = 'SalesAssisted',
  Unassisted = 'Unassisted',
  PartnerAssistedInPerson = 'PartnerAssistedInPerson',
}

enum SessionTypeTracking {
  Remote = 'remote',
  FaceToFace = 'face_to_face',
}

type TrackingContextName =
  | 'signup_core_services'
  | 'signup_application'
  | 'signup_remote_appointment'
  | 'signup_checkout'
  | 'signup_mobile_services';

export type { ReferrerTrackingContext, TrackingContextName };
export {
  ReferrerTypeTracking,
  AssistantTypeTracking,
  SalesMethodTracking,
  SessionTypeTracking,
};
